import { collectPages } from "../../shared/api/collect-pages.js";
import { useQuery } from "@tanstack/react-query";

import { requireData } from "../../shared/api/api-error.js";
import { useApi } from "../../shared/api/api-context.js";

export interface TradeFilters {
  readonly botId?: string;
  readonly brokerAccountId?: string;
  readonly from?: string;
  readonly orderId?: string;
  readonly symbol?: string;
  readonly to?: string;
}

export function useTrades(cursor: string, filters: TradeFilters, enabled = true) {
  const api = useApi();
  return useQuery({
    enabled,
    queryKey: ["trades", cursor, filters],
    queryFn: async ({ signal }) =>
      requireData(
        await api.GET("/trades", {
          params: { query: { limit: 50, ...(cursor === "" ? {} : { cursor }), ...filters } },
          signal,
        }),
      ),
    refetchInterval: 15_000,
  });
}

export function useAllTrades(_cursor: string, filters: TradeFilters, enabled = true) {
  const api = useApi();
  return useQuery({
    enabled,
    queryKey: ["trades", "list", filters],
    queryFn: async ({ signal }) =>
      collectPages(async (cursor) =>
        requireData(
          await api.GET("/trades", {
            params: { query: { limit: 100, ...(cursor === "" ? {} : { cursor }), ...filters } },
            signal,
          }),
        ),
      ),
    refetchInterval: 15_000,
  });
}

export function useTradePnlChart(
  filters: TradeFilters,
  groupBy: "date" | "week" | "month" | "symbol",
  enabled = true,
) {
  const api = useApi();
  return useQuery({
    enabled,
    queryKey: ["trades", "pnl", filters, groupBy],
    queryFn: async ({ signal }) =>
      requireData(
        await api.GET("/trades/pnl", { params: { query: { ...filters, groupBy } }, signal }),
      ),
    refetchInterval: 15_000,
  });
}
